// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.lock[data-v-5892a73e] {\r\n\tfont-size: 2em;\r\n\tcolor: #f3c43f;\n}\n.denied[data-v-5892a73e], .denied > span[data-v-5892a73e] { font-size: 24px; margin: 0 0 0 0; text-align: center;\n}\n.denied > span[data-v-5892a73e]{ display: block;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
